import { taxonomiesManifest } from '@/features/english-knowledge/taxonomies/manifest'
import { vocabulariesManifest } from '@/features/english-knowledge/vocabularies/manifest'
import { vocabularyGroupsManifest } from '@/features/english-knowledge/vocabulary-groups/manifest'
import { vocabularyFlashcardsManifest } from '@/features/english-knowledge/vocabulary-flashcards/manifest'
import { vocabularyGroupTaxonomiesManifest } from '@/features/english-knowledge/vocabulary-group-taxonomies/manifest'
import { levelsManifest } from '@/features/english-language-standards/levels/manifest'
import { standardsManifest } from '@/features/english-language-standards/standards/manifest'
import { lookupManifest } from '@/features/english-language-standards/lookup/manifest'
import { principlesManifest } from '@/features/english-language-standards/principles/manifest'
import { referencesManifest } from '@/features/english-language-standards/references/manifest'
import { lessonCatalogManifest } from '@/features/lessons/catalog/manifest'
import { lessonEditorManifest } from '@/features/lessons/editor/manifest'
import { lexicalsManifest } from '@/features/lessons/knowledge/lexicals/manifest'
import { sentencePatternsManifest } from '@/features/lessons/knowledge/sentence-patterns/manifest'
import { englishWorldManifest } from '@/features/english-world/manifest'
import { ttsManifest } from '@/features/tts/manifest'
import { googleDriveManifest } from '@/features/resources/google-drive/manifest'
import { filesManifest } from '@/features/resources/files/manifest'
import { communicativeFunctionsManifest } from '@/features/catalogs/communicative-functions/manifest'
import { sparkCurriculumManifest } from '@/features/curriculums/spark/manifest'

export const featureManifests = [
  sparkCurriculumManifest,
  communicativeFunctionsManifest,
  englishWorldManifest,
  lessonCatalogManifest,
  lexicalsManifest,
  levelsManifest,
  principlesManifest,
  standardsManifest,
  lookupManifest,
  referencesManifest,
  sentencePatternsManifest,
  lessonEditorManifest,
  taxonomiesManifest,
  vocabulariesManifest,
  vocabularyGroupTaxonomiesManifest,
  vocabularyGroupsManifest,
  vocabularyFlashcardsManifest,
  ttsManifest,
  googleDriveManifest,
  filesManifest,
]
